import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { currentUser_req, userConfirmation_req } from "../api/user.api";
import { topicAnswered_req } from "../api/profiles.api";
import { useDispatch } from "react-redux";
import { setMeData } from "../redux/me.slice";
import { getPendingSurvey, clearPendingSurvey } from "../utils/pendingSurvey";
import { setAuthToken } from "../utils/authToken";

const EmailConfirmation = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const confirmationToken = queryParams.get("confirmation_token");

  const getConfirmationToken = async () => {
    try {
      const response = await userConfirmation_req(confirmationToken);
      const token = response.headers["authorization"];
      setAuthToken(token, { rememberMe: false });
      const responseData = await currentUser_req();
      dispatch(setMeData(responseData?.user));

      const pendingSurvey = getPendingSurvey();

      if (pendingSurvey) {
        try {
          const reportResponse = await topicAnswered_req(pendingSurvey.profileId, pendingSurvey.topicId, pendingSurvey.answers);

          clearPendingSurvey();

          navigation(`/report/${pendingSurvey.profileId}?topic=${pendingSurvey.topicId}`, {
            state: { data: reportResponse },
          });
          return;
        } catch (reportError) {
          console.log("reportError", reportError);
          clearPendingSurvey();

          navigation(`/profiles/${pendingSurvey.profileId}/topics/${pendingSurvey.topicId}/questions`);
          return;
        }
      }

      navigation("/");
    } catch (e) {
      console.log("e", e);
    }
  };
  useEffect(() => {
    if (confirmationToken) {
      getConfirmationToken();
    }
  }, [confirmationToken]);
  return <div></div>;
};

export default EmailConfirmation;
